import Storage from './index';

class RefreshTokenStorage extends Storage {
  constructor() {
    super('RefreshToken');
  }
}

export default new RefreshTokenStorage();
